<template>
  <NuxtLink
    class="worldLink"
    :to="isExternalLink ? `${runtimeConfig.app.baseURL}${href.replace(/^\//, '')}` : href"
    :external="isExternalLink"
  >
    <span class="text">{{ text }}</span>
  </NuxtLink>
</template>

<script setup>

defineProps({
  text: {
    type: String,
    required: true
  },
  href: {
    type: String,
    required: true
  }
})

const runtimeConfig = useRuntimeConfig()
const { $isWebViewFlag: isWebViewFlag } = useNuxtApp()
const isExternalLink = ref(isWebViewFlag)

</script>

<style lang="scss" scoped>
.worldLink {
  width: 100%;
  position: relative;
  padding: 9px 10px 8px;
  border-radius: 4px;
  border: 1px solid #3569C0;
  background-color: #fff;
  user-select: none;
  box-shadow: 0 2px 4px 1px rgb(0 0 0 / .2);
  background-image: url('~/assets/images/common/icon_arrow_blue.svg');
  background-position: right 10px center;
  background-repeat: no-repeat;
  background-size: 9px;
  .text {
    display: block;
    padding-left: 25px;
    padding-right: 15px;
    background-image: url('https://gvs.weathernews.jp/onebox/img/icon/list-menu_icon_world.svg');
    background-position: left center;
    background-repeat: no-repeat;
    background-size: 20px;
    color: #3569C0;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }
  @media (any-hover: hover) {
    transition: box-shadow .2s ease-in-out;
    &:hover {
      box-shadow: 0 2px 6px 1px rgb(0 0 0 / .45);
    }
  }
}
</style>
